import BaseRepository from './base.repository';

// Bound the startup request so an unavailable endpoint promptly exposes retry.
const VERSION_REQUEST_TIMEOUT_MS = 5000;

class AppVersionRepository extends BaseRepository {
  constructor() {
    super('/version');
  }

  getVersion() {
    // Pre-login config check: silent background read with no spinner and no JWT.
    return this.client.get('', undefined, {
      silent: true,
      noLoading: true,
      publicAuth: true,
      sessionIndependent: true,
      timeout: VERSION_REQUEST_TIMEOUT_MS,
    });
  }
}

export default new AppVersionRepository();
